/**
 * Labstep
 */

import { Flex } from 'labstep-web/core/Flex';
import { ModalWizardHeaderStep } from 'labstep-web/core/Modal/Wizard/Header/Steps/Step';
import type React from 'react';
import { Fragment } from 'react';
import { Image } from 'semantic-ui-react';
import type { IModalWizardHeaderStepsProps } from './types';

export const ModalWizardHeaderSteps: React.FC<
  IModalWizardHeaderStepsProps
> = ({ steps, activeStepIndex, mode }) => {
  const hideStepNames = mode === 'mini' && steps.length > 2;

  return (
    <Flex
      hAlignContent="center"
      style={{ overflow: 'hidden', minWidth: 0 }}
    >
      {steps.map((step, index) => (
        <Fragment key={step}>
          <ModalWizardHeaderStep
            step={step}
            number={index + 1}
            active={activeStepIndex === index}
            complete={activeStepIndex > index}
            hideStepName={hideStepNames}
          />
          {index < steps.length - 1 && (
            <Image
              src="/img/icon/chevron.svg"
              style={{ flexShrink: 0 }}
            />
          )}
        </Fragment>
      ))}
    </Flex>
  );
};
